/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, company: NonNullable<unknown>, status: NonNullable<unknown> }} Interview_Prepare_Job_OptionInputs */

const en_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} at ${i?.company} (${i?.status})`)
};

const de_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} bei ${i?.company} (${i?.status})`)
};

const fr_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} chez ${i?.company} (${i?.status})`)
};

const es_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} en ${i?.company} (${i?.status})`)
};

const it_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} presso ${i?.company} (${i?.status})`)
};

const nl_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} bij ${i?.company} (${i?.status})`)
};

const pl_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} w ${i?.company} (${i?.status})`)
};

const fi_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} yrityksessä ${i?.company} (${i?.status})`)
};

const da_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} hos ${i?.company} (${i?.status})`)
};

const sv_interview_prepare_job_option = /** @type {(inputs: Interview_Prepare_Job_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} på ${i?.company} (${i?.status})`)
};

/**
* | output |
* | --- |
* | "{title} at {company} ({status})" |
*
* @param {Interview_Prepare_Job_OptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_job_option = /** @type {((inputs: Interview_Prepare_Job_OptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Job_OptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_job_option(inputs)
	if (locale === "fr") return fr_interview_prepare_job_option(inputs)
	if (locale === "es") return es_interview_prepare_job_option(inputs)
	if (locale === "it") return it_interview_prepare_job_option(inputs)
	if (locale === "nl") return nl_interview_prepare_job_option(inputs)
	if (locale === "pl") return pl_interview_prepare_job_option(inputs)
	if (locale === "fi") return fi_interview_prepare_job_option(inputs)
	if (locale === "da") return da_interview_prepare_job_option(inputs)
	if (locale === "sv") return sv_interview_prepare_job_option(inputs)
	return en_interview_prepare_job_option(inputs)
});